import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        is_loading: true,
        is_show_loading: false,
        show_sub_menu: false,
        footer: false,
        cookies: false,
        social: false,
        global: false,
        disabled_scroll: false,
        collection: false,
        highlights: false,
        is_show_mobile_navi: false,
    },
    // mutations: {
    // },
    // actions: {
    // },
    // modules: {
    // }
})
